<div class="groups-user">
  <div class="groups-user__groups">
    <div class="groups-user__groups__title">
      <span> {{ dataTranslateUserGroups?.title }} </span>
      <button (click)="addGroup()">
        <mat-icon>add</mat-icon>
        <span> {{ dataTranslateUserGroups?.buttonNew }} </span>
      </button>
    </div>
    <div class="groups-user__groups__search">
      <input
        type="text"
        [(ngModel)]="search"
        [placeholder]="dataTranslateUserGroups?.search"
      />
    </div>
    <div class="groups-user__groups__container" *ngIf="loading">
      <div class="loading">
        <img src="https://cdn.mango-soft.com/mango-core/loading.gif" alt="" />
      </div>
    </div>
    <div class="groups-user__groups__container" *ngIf="!loading">
      <div
        class="groups-user__groups__container__card"
        (click)="selectedGroup(item)"
        [ngClass]="{
          'card-selected': groupUserSelected && groupUserSelected.group.sk === item.group.sk
        }"
        *ngFor="let item of groupsUsers | search : search"
      >
        <div class="groups-user__groups__container__card__img">
          <img
            [src]="item.group?.picture"
            onerror="this.onerror=null;this.src='https://cdn.mango-soft.com/default-image.svg';"
            alt=""
          />
        </div>
        <div class="groups-user__groups__container__card__title">
          <span class="groups-user__groups__container__card__title__name">
            {{ item.group.name }}
          </span>
          <span class="groups-user__groups__container__card__title__users">
            {{ item.users.length }}
            {{ dataTranslateUserGroups?.subTitle | lowercase }}
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="groups-user__users" *ngIf="loading">
    <div class="loading">
      <img src="https://cdn.mango-soft.com/mango-core/loading.gif" alt="" />
    </div>
  </div>
  <div
    class="groups-user__users"
    *ngIf="groupUserSelected?.group?.sk && !loading"
  >
    <div class="groups-user__users__title">
      <span class="groups-user__users__title__group">
        {{ groupUserSelected.group.name }}
      </span>
      <span class="groups-user__users__title__id"
        >ID:{{ groupUserSelected.group.sk }}
      </span>
    </div>
    <div class="groups-user__users__sub-title">
      <span> {{ dataTranslateUserGroups?.subTitle }} </span>
    </div>
    <div class="groups-user__users__table">
      <div class="groups-user__users__table__pagination">
        <div class="groups-user__users__table__pagination__buttons">
          <!-- <button
            (click)="showSearch = !showSearch"
            [ngClass]="{ 'active-search': showSearch }"
          >
            <mat-icon>search</mat-icon>
            <span> {{ dataTranslateUserGroups?.buttonSearch }} </span>
          </button> -->
          <button (click)="allDelete()" [disabled]="selected.length === 0">
            <mat-icon>delete</mat-icon>
            <span> {{ dataTranslateUserGroups?.buttonDelete }} </span>
          </button>
          <button (click)="loadGroupsUsers(groupUserSelected)">
            <mat-icon [ngClass]="{ 'active-refresh': loading }">
              autorenew
            </mat-icon>
            <span> {{ dataTranslateUserGroups?.buttonRefresh }} </span>
          </button>
          <button (click)="addUser()">
            <mat-icon> add </mat-icon>
            <span> Add </span>
          </button>
        </div>
        <div class="groups-user__users__table__pagination__content-pagination">
          <!-- <button>
            <mat-icon>settings</mat-icon>
            <span> Settings </span>
          </button> -->
        </div>
      </div>
      <div
        class="layout-search"
        [ngClass]="{ 'filters-exit': !showSearch, view_aside: showSearch }"
      >
        <div
          class="filter"
          [ngClass]="{ hidden: !showSearch, block: showSearch }"
        >
          <app-filter [options]="columns"></app-filter>
        </div>
      </div>
      <div
        class="groups-user__users__table__content-pagination"
        [ngClass]="{ 'active-search-table': showSearch }"
      >
        <div class="loading" *ngIf="loadingTable">
          <img src="https://cdn.mango-soft.com/mango-core/loading.gif" alt="" />
        </div>
        <ngx-datatable
          class="material"
          style="width: 100%; height: 100%; box-shadow: none"
          [columns]="columns"
          [rows]="groupUserSelected.users || []"
          [columnMode]="modeColum"
          [headerHeight]="44"
          [footerHeight]="0"
          [rowHeight]="50"
          *ngIf="!loadingTable"
          (select)="onSelect($event)"
          [limit]="10"
          [selected]="selected"
          [scrollbarH]="false"
          [scrollbarV]="false"
          [messages]="{ emptyMessage: '' }"
          [selectionType]="selectionType.checkbox"
          [sorts]="[{ prop: 'name', dir: 'asc' }]"
        >
          <ngx-datatable-column
            [width]="30"
            [canAutoResize]="false"
            [draggable]="false"
            [resizeable]="false"
          >
            <ng-template
              ngx-datatable-header-template
              let-value="value"
              let-allRowsSelected="allRowsSelected"
              let-selectFn="selectFn"
            >
              <input
                type="checkbox"
                [checked]="allRowsSelected"
                (change)="selectFn(!allRowsSelected)"
                src="../../../../assets/icons/refresh-icon.svg"
              />
            </ng-template>
            <ng-template
              ngx-datatable-cell-template
              let-value="value"
              let-isSelected="isSelected"
              let-onCheckboxChangeFn="onCheckboxChangeFn"
            >
              <input
                type="checkbox"
                [checked]="isSelected"
                (change)="onCheckboxChangeFn($event)"
              />
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column
            [sortable]="true"
            [name]="columnsElement.name"
            *ngFor="
              let columnsElement of dataTranslateUserGroups?.tableColumns ||
                columns
            "
            [resizeable]="false"
            headerClass="cell-email"
            [cellClass]="getClass"
          >
            <ng-template
              ngx-datatable-header-template
              let-value="value"
              let-allRowsSelected="allRowsSelected"
              let-selectFn="selectFn"
            >
              <div class="w-full flex justify-start">
                <span> {{ columnsElement?.label || "" }} </span>
              </div>
            </ng-template>
            <ng-template
              ngx-datatable-cell-template
              let-value="value"
              let-allRowsSelected="allRowsSelected"
              let-selectFn="selectFn"
            >
              {{ value | titlecase }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column
            [name]="dataTranslateUserGroups?.tableColumRole.label"
            cellClass="role"
            [sortable]="false"
          >
            <ng-template
              let-row="row"
              let-value="value"
              ngx-datatable-cell-template
            >
              <div *ngIf="row.status !== 'active'" class="status-roles">
                <span>
                  {{ row?.roles[0].properties.name }}
                </span>
              </div>
              <mat-select
                *ngIf="row.status === 'active'"
                [value]="row?.roles[0].properties.name"
                (selectionChange)="selectionChange(row, $event)"
              >
                <mat-option *ngFor="let role of getRoles()" [value]="role">{{
                  role
                }}</mat-option>
              </mat-select>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column
            name="actions"
            headerClass="cell-actions"
            [width]="100"
            cellClass="cell-actions"
            [sortable]="false"
          >
            <ng-template
              ngx-datatable-header-template
              class="cell-actions"
              let-value="value"
              let-allRowsSelected="allRowsSelected"
              let-selectFn="selectFn"
            >
              <div class="">
                <!-- {{ dataTranslateUserGroups?.tableColumActions.label }} -->
              </div>
            </ng-template>
            <ng-template
              let-row="row"
              let-value="value"
              ngx-datatable-cell-template
            >
              <div class="icons-actions" *ngIf="selected.length === 0">
                <div
                  class="icon-delete"
                  [matTooltip]="dataTranslateUserGroups?.tooltipDelete"
                  (click)="removeUser(row)"
                >
                  <mat-icon>delete</mat-icon>
                </div>
                <div class="isActivatedUser" *ngIf="row.status === 'active'">
                  <mat-icon>forward_to_inbox</mat-icon>
                </div>
                <div
                  class="icon active"
                  (click)="resend(row)"
                  [matTooltip]="dataTranslateUserGroups?.tooltipResend"
                  *ngIf="row.status !== 'active'"
                >
                  <mat-icon>forward_to_inbox</mat-icon>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>
